module.exports = "pegasus_template/assets/styleGroup2-facebook.gif";